import PropTypes from 'prop-types';

// these could be specified by the theme
export const DURATION = 1800;
export const MIN_EMPTY_ANGLE = 60;
export const MIN_STROKE_ANGLE = 30;
export const BEZIER = [0.42, 0.0, 0.58, 1.0];
export const propTypes = {
  color: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  size: PropTypes.number.isRequired,
  thickness: PropTypes.number.isRequired,
  isStatic: PropTypes.bool
};